// router/index.js
import { createRouter, createWebHistory } from "vue-router";
import {  showCustom } from "@/assets/js/utils/alertService"; // ✅ 改用公用方法
import api from "@/assets/js/utils/api.js";
import Login from "@/view/LoginPage.vue";
import Register from "@/view/RegisterPage.vue";
import Forgot from "@/view/ForgotPage.vue";
import Reset from "@/view/ResetPage.vue";
import Products from "@/view/ProductsPage.vue";
import Video from "@/view/VideoPage.vue";
import Contact from "@/view/ContactPage.vue";
import Cart from "@/view/CartPage.vue";
import Home from "@/view/HomePage.vue";
import UserDashboard from "@/view/UserDashboard.vue";
import Checkout from "@/view/CheckoutPage.vue";
import LineCallBack from "@/view/LineCallBack.vue";
import GoogleCallBack from "@/view/GoogleCallBack.vue";
import OrderSuccess from "@/view/OrderPage.vue";
import Healthy from "@/view/HealthyPage.vue";

// ✅ 導出路由表（全部平面化）
const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { title: "首頁｜安裕和國際企業社" },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { hideFooter: true, title: "會員登入｜安裕和國際企業社" },
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: { hideFooter: true, title: "會員註冊｜安裕和國際企業社" },
  },
  {
    path: "/forgot",
    name: "Forgot",
    component: Forgot,
    meta: { hideFooter: true, title: "忘記密碼｜安裕和國際企業社" },
  },
  {
    path: "/reset",
    name: "Reset",
    component: Reset,
    meta: { hideFooter: true, title: "重設密碼｜安裕和國際企業社" },
  },
  {
    path: "/products",
    name: "Products",
    component: Products,
    meta: { title: "商品專區｜安裕和國際企業社" },
  },
  {
    path: "/products/:id",
    name: "ProductDetailInList",
    component: Products,
    meta: { title: "商品詳情｜安裕和國際企業社" },
  },
  {
    path: "/healthy",
    name: "Healthy",
    component: Healthy,
    meta: { title: "衛教專區｜安裕和國際企業社" },
  },
  {
    path: "/video",
    name: "Video",
    component: Video,
    meta: { title: "教學影片｜安裕和國際企業社" },
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
    meta: { title: "聯絡我們｜安裕和國際企業社" },
  },
  {
    path: "/cart",
    name: "Cart",
    component: Cart,
    meta: { requiresAuth: true, title: "購物車｜安裕和國際企業社" }, // 需要登入驗證
  },
  {
    path: "/checkout",
    name: "Checkout",
    component: Checkout,
    meta: { requiresAuth: true, title: "結帳頁面｜安裕和國際企業社" }, // 需要登入驗證
  },
  {
    path: "/line/callback",
    name: "LineCallBack",
    component: LineCallBack,
  },
  {
    path: "/google/callback",
    name: "GoogleCallBack",
    component: GoogleCallBack,
  },
  {
    path: "/order-success/:orderNo?", // ✅ 新增訂單成立頁面路由
    name: "OrderSuccess",
    component: OrderSuccess,
    meta: { requiresAuth: true, title: "訂單完成｜安裕和國際企業社" }, // 需要登入驗證
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: UserDashboard,
    meta: { requiresAuth: true, hideFooter: true }, // 需要登入驗證
    children: [
      {
        path: "",
        name: "DashboardHome",
        redirect: "/dashboard/profile",
      },
      {
        path: "profile",
        name: "DashboardProfile",
        component: UserDashboard,
        meta: { tab: "profile" },
      },
      {
        path: "orders",
        name: "DashboardOrders",
        component: UserDashboard,
        meta: { tab: "orders" },
      },
      {
        path: "coupons",
        name: "DashboardCoupons",
        component: UserDashboard,
        meta: { tab: "coupons" },
      },
      {
        path: "settings",
        name: "DashboardSettings",
        component: UserDashboard,
        meta: { tab: "settings" },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,

  // ✅ 這裡！！切換分頁時捲動回頂部
  scrollBehavior(_, __, savedPosition) {
    if (savedPosition) return savedPosition;
    return { top: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  const authFreePages = ["/login", "/register", "/forgot", "/reset"]; // 註解：控制訪客專用頁

  // 🟦 Step 1：若使用者已登入卻想進 login/register → 擋掉  // 註解：控制登入後限制頁
  try {
    const res = await api.get("/front/customer/verify");
    const isLoggedIn = res.data?.success === true;

    if (isLoggedIn && authFreePages.includes(to.path)) {
      await showCustom("您已登入", "將返回會員中心。", "info");
      return next("/dashboard");
    }

    // 🟦 Step 2：需要登入的頁面 → 驗證失敗則擋掉  // 註解：控制需要授權頁面
    if (to.meta.requiresAuth && !isLoggedIn) {
      await showCustom("登入失效", "請重新登入。", "warning");
      return next("/login");
    }

    // 🟦 Step 3：其他頁面 → 正常放行  // 註解：控制正常通行
    return next();
  } catch (err) {
    console.error("verify 失敗:", err);

    // verify API 掛掉（通常 server 掛 / cookie 過期）
    if (to.meta.requiresAuth) {
      await showCustom("登入狀態已失效", "請重新登入。", "warning");
      return next("/login");
    }

    return next();
  }
});

router.afterEach((to) => {
  const navbar = document.querySelector("app-navbar"); // 取得元件節點
  if (navbar && typeof navbar.__vue__.checkLoginStatus === "function") {
    navbar.__vue__.checkLoginStatus(); // 重新檢查登入狀態
  }

  // 🟦 SEO：動態切換 Title
  const defaultTitle = "安裕和國際企業社｜醫療器材與寵物用品批發專家";
  document.title = to.meta.title || defaultTitle;
});

// ✅ 導出 router
export default router;
